import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './utils/PrivateRoute';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Layout
import Layout from './components/layout/Layout';

// Dashboard Pages
import Dashboard from './pages/dashboard/Dashboard';
import AdminDashboard from './pages/dashboard/AdminDashboard';
import UserDashboard from './pages/dashboard/UserDashboard';

// Admin Pages
import UsersList from './pages/admin/UsersList';
import ChannelsList from './pages/admin/ChannelsList';
import VideosList from './pages/admin/VideosList';

// User Pages
import MyChannels from './pages/user/MyChannels';
import MyVideos from './pages/user/MyVideos';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/dashboard/users"
            element={
              <PrivateRoute requireAdmin>
                <Layout>
                  <UsersList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/channels"
            element={
              <PrivateRoute requireAdmin>
                <Layout>
                  <ChannelsList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/videos"
            element={
              <PrivateRoute requireAdmin>
                <Layout>
                  <VideosList />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* User Routes */}
          <Route
            path="/dashboard/my-channels"
            element={
              <PrivateRoute>
                <Layout>
                  <MyChannels />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/my-videos"
            element={
              <PrivateRoute>
                <Layout>
                  <MyVideos />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </AuthProvider>
  );
}

export default App;
